import styles from '../../ProgramDetail.module.scss'

import { Badge, Flex, Tooltip } from '@percent/lemonade'
import { ProgramStatusBadge } from './ProgramStatusBadge'

export function ProgramDetailTable({
  title,
  items,
  status
}: Readonly<{
  title: string
  items?: readonly string[]
  status?: 'on' | 'off'
}>) {
  if (!items?.length) return null

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{title}</th>
          <th aria-label="Status" />
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <Flex gap={8} wrap="wrap">
              {items.map(item => {
                if (item.length > 60)
                  return (
                    <Tooltip content={item} key={item}>
                      <div className={styles.clampedBadge}>
                        <Badge variant="default">
                          <p>{item}</p>
                        </Badge>
                      </div>
                    </Tooltip>
                  )

                return (
                  <Badge variant="default" key={item}>
                    {item}
                  </Badge>
                )
              })}
            </Flex>
          </td>
          <td className={styles.mode}>{status && <ProgramStatusBadge status={status} />}</td>
        </tr>
      </tbody>
    </table>
  )
}
